import { get, each } from "lodash";

import i18n from "i18next";

import settings from "./settings";

const language = settings.realm.languageCode;
let catalog = get(window, 'i18n.catalog', {});

let i18nextTranslations = {};
each(catalog, (translations, key) => {

  let pluralizable = Array.isArray(translations);

  if (pluralizable) {
    each(translations, (translation, index) => {
      i18nextTranslations[`${key}_${index}`] = translation;
    });
  } else {
    i18nextTranslations[key] = translations;
  }
});

let i18nextResources = {
  [language]: {
    wows: i18nextTranslations
  }
};

i18n.init({
  nsSeparator: false,
  keySeparator: false,
  fallbackLng: false,
  lowerCaseLng: true,

  lng: language,

  resources: i18nextResources,
  ns: ['wows'],
  defaultNS: 'wows',

  debug: false,

  interpolation: {
    prefix: '%(',
    suffix: ')s',
    escapeValue: false
  }
});

export default i18n;